import { render } from "./BrandUpdate.vue?vue&type=template&id=384d8352"
import script from "./BrandUpdate.vue?vue&type=script&lang=js"
export * from "./BrandUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__